import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

// Group navigation can be customize by the Admin in the BO
const useGroupNavigationTheme = ({ network } = {}) => {
  const { currentNetwork } = useDefaultAppContexts();

  const networkData = network || currentNetwork;

  return {
    backgroundColor: networkData?.theming?.fo?.fo_group_menu_background_color,
    fontBrightness: networkData?.theming?.fo?.fo_group_menu_font_brightness,
    themeName: 'fo',
  };
};

export default useGroupNavigationTheme;
